import React, { useState } from "react";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import axios from "axios";
import Swal from "sweetalert2";


const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    message: ""
  });
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${BASE_URL}/api/contact`, formData);
      Swal.fire(
        'Message Sent!',
        'We will get in touch with you soon.',
        'success'
      );

      setFormData({
        name: "",
        email: "",
        phone: "",
        address: "",
        message: ""
      });
    } catch (error) {
      Swal.fire(
        'Oops!',
        'Failed to send message. Please try again later.',
        'error'
      );
    }
  };

  return (
    <>
      <header style={{ width: "100%", height: "auto" }}>
        <div
          style={{
            width: "100%",
            height: "400px",
            backgroundImage: "url('assets/images/Bulk/25.jpg')",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        ></div>
      </header>

      <section id="contact" style={{ padding: "1.5rem", backgroundColor: "white", color: "black" }}>
        <div style={{ maxWidth: "1024px", margin: "0 auto", textAlign: "center" }}>
          <h2 style={{ fontSize: "2rem", fontWeight: "bold", marginBottom: "1.5rem" }}>
            Contact Us
          </h2>
          <p style={{ fontSize: "1.125rem", marginBottom: "2.5rem" }}>
            We'd love to hear from you! Reach out to us through the details below or visit us at our location.
          </p>

          {/* Contact Info */}
          <div className="contact-info">
            <div className="contact-item">
              <FaMapMarkerAlt style={iconStyle} />
              <h3 style={headingStyle}>Address</h3>
              <p>2nd Floor, Plot No.79,<br />New Diamond Nagar, Kharbi, Nagpur, Maharashtra 440024</p>
            </div>
            <div className="contact-item">
              <FaPhoneAlt style={iconStyle} />
              <h3 style={headingStyle}>Phone</h3>
              <p><a href="tel:+917888020432">+91 9009279769 </a></p>
              <p><a href="tel:+917974472452">+91 7974472452</a></p>
            </div>
            <div className="contact-item">
              <FaEnvelope style={iconStyle} />
              <h3 style={headingStyle}>Email</h3>
              <p><a href="mailto:contact@romiyography.com">contact@romiyography.com</a></p>
            </div>

          </div>

          {/* Contact Form + Map */}
          <div className="form-map-wrapper">
            {/* Form */}
            <div className="contact-form">
              <h1 style={{ marginBottom: "1rem", fontSize: "1.6rem" }}>Send a Message</h1>
              <form onSubmit={handleSubmit}>
                <input
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  type="text"
                  placeholder="Name"
                  required
                />
                <input
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  type="email"
                  placeholder="Email"
                  required
                />
                <input
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  type="tel"
                  placeholder="Phone Number"
                  required
                />
                <textarea
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  placeholder="Address"
                  rows="3"
                  required
                ></textarea>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Enter your enquiry and we’ll get back to you shortly..."
                  rows="4"
                  required
                ></textarea>
                <button type="submit">Get in Touch</button>
              </form>
            </div>

            {/* Map */}
            <div className="contact-map">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3721.599365832283!2d79.13205347401222!3d21.128532884346605!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd4c7094ce36eaf%3A0x1ff09c81e2222ccf!2sRomiyography!5e0!3m2!1sen!2sin!4v1735120877885!5m2!1sen!2sin"
                width="100%"
                height="100%"
                style={{ border: "0" }}
                allowFullScreen=""
                loading="lazy"
                title="Google Map"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      <style jsx>{`
        .contact-info {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          gap: 1.5rem;
        }

        .contact-item {
          flex: 1 1 calc(33.333% - 1.5rem);
          text-align: center;
          padding: 1rem;
          box-sizing: border-box;
        }

        .form-map-wrapper {
          display: flex;
          flex-wrap: wrap;
          margin-top: 3rem;
          gap: 2rem;
        }

        .contact-form,
        .contact-map {
          flex: 1 1 48%;
          min-width: 300px;
        }

        .contact-form form {
          display: flex;
          flex-direction: column;
        }

        .contact-form input,
        .contact-form textarea {
          padding: 0.75rem;
          margin-bottom: 1rem;
          border: 1px solid #ccc;
          border-radius: 4px;
          font-size: 1rem;
        }

        .contact-form button {
          padding: 0.75rem;
          background-color: #000;
          color: #fff;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          font-size: 1rem;
        }

        .contact-form button:hover {
          background-color: #333;
        }

        .contact-map iframe {
          width: 100%;
          height: 100%;
          min-height: 300px;
          border-radius: 8px;
        }

        @media (max-width: 768px) {
          .contact-info,
          .form-map-wrapper {
            flex-direction: column;
          }
        }
      `}</style>
    </>
  );
};

const iconStyle = {
  fontSize: "2.5rem",
  marginBottom: "1rem",
  display: "inline-block",
  verticalAlign: "middle",
};

const headingStyle = {
  fontSize: "1.25rem",
  fontWeight: "600",
  marginBottom: "0.5rem",
};

export default Contact;
